export default __webpack_public_path__ + "static/media/icon_camera.9d869718.svg";